import React, { FunctionComponent, useCallback, useMemo } from "react"
import { Link, useHistory, useRouteMatch } from "react-router-dom"
import DotButton from "../../components/Buttons/DotButton"
import { eImageVersions } from "../../definitions/Image"
import { useImage } from "../../hooks/useImage"
import { useImageUrl } from "../../hooks/useImageUrl"
import { getArtistRoutes } from "./inspector/routes"

interface iProps {
  // published: boolean
  title: string
  type?: "create" | "edit"
  submitDeleteText: string
  submitText: string
  handleSubmit?: () => void
  handleDelete?: () => void
  isLoading?: boolean
  cover?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  access?: any
  published?: boolean
}

const ArtistHeader: FunctionComponent<iProps> = ({
  handleSubmit,
  handleDelete,
  title,
  cover,
  submitDeleteText,
  submitText,
  access,
  type = "edit",
  isLoading = false,
  published,
}) => {
  const history = useHistory()
  const match = useRouteMatch()
  const handleHisoryBack = useCallback((e: React.SyntheticEvent) => {
    e.preventDefault()
    history.goBack()
  }, [])

  const navRoutes = useMemo(
    () =>
      getArtistRoutes({
        urlPrefix: match.url,
      }),
    [match.url],
  )

  const { file } = useImage({
    fileId: cover,
    fileCollection: "Files_ArtistsProfilePictures",
  })

  const coverImage =
    file && useImageUrl(eImageVersions.XLWRegular, file.versions)

  return (
    <div className="inspector-header">
      <div className="inspector-cover-wrap">
        <div
          className="inspector-cover"
          style={{ backgroundImage: `url(${coverImage})` }}
        ></div>
        <div className="inspector-cover-overlay">
          <div className="inspector-headline">
            <Link to={"#"} onClick={handleHisoryBack}>
              <i className="fa fa-chevron-left"></i>
              <span>Back</span>
            </Link>

            <div className="d-flex">
              {access && access.canDelete && (
                <DotButton
                  isLoading={isLoading}
                  className={`btn-red submit-button`}
                  text={submitDeleteText}
                  onClick={handleDelete}
                  type="button"
                >
                  {submitDeleteText}
                </DotButton>
              )}
              {(type === "create" || (access && access.canEdit)) && (
                <DotButton
                  className={`btn-blue submit-button`}
                  text={submitText}
                  isLoading={isLoading}
                  onClick={handleSubmit}
                  type="button"
                >
                  {submitText}
                </DotButton>
              )}
            </div>
          </div>
          <h1 className="inspector-title">{title}</h1>
        </div>
      </div>
      {published !== undefined ? (
        published ? (
          <div className="published">This Artist is created!</div>
        ) : (
          <div className="draft">This Art Piece is a draft!</div>
        )
      ) : null}
      <div className="inspector-navigation">
        <ul>
          {navRoutes.map((n, i) => (
            <li
              key={i}
              className={history.location.pathname === n.route ? "active" : ""}
            >
              <Link to={n.route} replace>
                {n.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default ArtistHeader
